// extracted by mini-css-extract-plugin
export default {"Connector--row":"RgJZ2","Connector--column":"BCJDO"};